import { extractInkindPageRouteId } from '@gik/core/utils/LinkUtils';
import React from 'react';
import InKindOrganizers from './InKindOrganizers';

export interface IInKindOrganizersContainerProps {}

export default function InKindOrganizersContainer({}: React.PropsWithChildren<
  IInKindOrganizersContainerProps
>): JSX.Element {
  return (
    <div className="inkind-organizers-container">
      <InKindOrganizers routeId={extractInkindPageRouteId()}></InKindOrganizers>
    </div>
  );
}
